/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetEndpointPolicies200Item,
  PostEndpointPolicies200,
  PostEndpointPoliciesBody,
  PutEndpointPoliciesId200,
  PutEndpointPoliciesIdBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Lists endpoint policies with their API scopes and assigned roles.
 * @summary List endpoint policies
 */
export const getEndpointPolicies = (signal?: AbortSignal) => {
  return apiClient<GetEndpointPolicies200Item[]>({
    url: `/endpoint-policies`,
    method: 'GET',
    signal,
  });
};

export const getGetEndpointPoliciesQueryKey = () => {
  return [`/endpoint-policies`] as const;
};

export const getGetEndpointPoliciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEndpointPolicies>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getEndpointPolicies>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEndpointPoliciesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEndpointPolicies>>
  > = ({ signal }) => getEndpointPolicies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEndpointPolicies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEndpointPoliciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEndpointPolicies>>
>;
export type GetEndpointPoliciesQueryError = unknown;

export function useGetEndpointPolicies<
  TData = Awaited<ReturnType<typeof getEndpointPolicies>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEndpointPolicies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEndpointPolicies>>,
          TError,
          Awaited<ReturnType<typeof getEndpointPolicies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEndpointPolicies<
  TData = Awaited<ReturnType<typeof getEndpointPolicies>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEndpointPolicies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEndpointPolicies>>,
          TError,
          Awaited<ReturnType<typeof getEndpointPolicies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEndpointPolicies<
  TData = Awaited<ReturnType<typeof getEndpointPolicies>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEndpointPolicies>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List endpoint policies
 */

export function useGetEndpointPolicies<
  TData = Awaited<ReturnType<typeof getEndpointPolicies>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEndpointPolicies>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEndpointPoliciesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates an endpoint policy from a set of API scopes.
 * @summary Create endpoint policy
 */
export const postEndpointPolicies = (
  postEndpointPoliciesBody: PostEndpointPoliciesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostEndpointPolicies200>({
    url: `/endpoint-policies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEndpointPoliciesBody,
    signal,
  });
};

export const getPostEndpointPoliciesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEndpointPolicies>>,
    TError,
    { data: PostEndpointPoliciesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEndpointPolicies>>,
  TError,
  { data: PostEndpointPoliciesBody },
  TContext
> => {
  const mutationKey = ['postEndpointPolicies'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEndpointPolicies>>,
    { data: PostEndpointPoliciesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEndpointPolicies(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEndpointPoliciesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEndpointPolicies>>
>;
export type PostEndpointPoliciesMutationBody = PostEndpointPoliciesBody;
export type PostEndpointPoliciesMutationError = unknown;

/**
 * @summary Create endpoint policy
 */
export const usePostEndpointPolicies = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postEndpointPolicies>>,
      TError,
      { data: PostEndpointPoliciesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postEndpointPolicies>>,
  TError,
  { data: PostEndpointPoliciesBody },
  TContext
> => {
  const mutationOptions = getPostEndpointPoliciesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an endpoint policy and replaces its API scopes when provided.
 * @summary Update endpoint policy
 */
export const putEndpointPoliciesId = (
  id: string,
  putEndpointPoliciesIdBody: PutEndpointPoliciesIdBody,
) => {
  return apiClient<PutEndpointPoliciesId200>({
    url: `/endpoint-policies/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putEndpointPoliciesIdBody,
  });
};

export const getPutEndpointPoliciesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putEndpointPoliciesId>>,
    TError,
    { id: string; data: PutEndpointPoliciesIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putEndpointPoliciesId>>,
  TError,
  { id: string; data: PutEndpointPoliciesIdBody },
  TContext
> => {
  const mutationKey = ['putEndpointPoliciesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putEndpointPoliciesId>>,
    { id: string; data: PutEndpointPoliciesIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putEndpointPoliciesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEndpointPoliciesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEndpointPoliciesId>>
>;
export type PutEndpointPoliciesIdMutationBody = PutEndpointPoliciesIdBody;
export type PutEndpointPoliciesIdMutationError = unknown;

/**
 * @summary Update endpoint policy
 */
export const usePutEndpointPoliciesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putEndpointPoliciesId>>,
      TError,
      { id: string; data: PutEndpointPoliciesIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putEndpointPoliciesId>>,
  TError,
  { id: string; data: PutEndpointPoliciesIdBody },
  TContext
> => {
  const mutationOptions = getPutEndpointPoliciesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes an endpoint policy and removes it from every role it is assigned to.
 * @summary Delete endpoint policy
 */
export const deleteEndpointPoliciesId = (id: string) => {
  return apiClient<unknown>({
    url: `/endpoint-policies/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteEndpointPoliciesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEndpointPoliciesId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEndpointPoliciesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteEndpointPoliciesId'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEndpointPoliciesId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEndpointPoliciesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEndpointPoliciesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEndpointPoliciesId>>
>;

export type DeleteEndpointPoliciesIdMutationError = unknown;

/**
 * @summary Delete endpoint policy
 */
export const useDeleteEndpointPoliciesId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEndpointPoliciesId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEndpointPoliciesId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteEndpointPoliciesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
